























































































































































































import Vue from "vue";
import identityAuthenClient from "@/services/identityAuthenClient";
import userInfoProvider from "@/services/userInfoProvider";
import OtpFormInput from "@/views/login/partials/OtpFormInput.vue";
import merge from "@vuetifyx/utils/merge";

export default Vue.extend({
  components: {OtpFormInput},
  data() {
    return {
      showNoti: false,
      error: "",
      messageNoti: "",
      totpData: "",
      messageUpdate: "",
      data: {},
      dataUpdate: "",
      loginDialog: false,
      editDialog: false,
      verifyInfo: false,
      requestId: "",
      sessionId: "",
      userInfo: {
        email: "",
        phone: "",
      },
      mfas: {},
      updateType: "",
      mfaUpdateState: "",
      mfaSetAsDefault: "",
      errorLoginUpdate: "",
      initError: "",
      updateError: "",
      loading: false,
    };
  },
  watch: {
    loginDialog: {
      handler(val) {
        this.errorLoginUpdate = ""
        this.data.password = ""
      },
      deep: true,
    },
    editDialog: {
      handler(val) {
        this.errorLoginUpdate = ""
      },
      deep: true,
    }
  },
  mounted() {
    this.refreshMfas();
  },
  methods: {
    parseData(dataStr) {
      return JSON.parse(dataStr);
    },
    imageSrc(dataStr) {
      const qr = this.parseData(dataStr).qr;
      return `data:image/png;base64,${qr}`;
    },
    editHanlder(key) {
      const updateToken = localStorage.getItem("update_token");
      this.updateType = key;
      this.verifyInfo = false;
      this.messageUpdate = "";
      if (updateToken) {
        this.loginDialog = false;
        this.editDialog = true;
        if (key === 'Totp') {
          this.submitUpdate()
        }
      } else {
        this.loginDialog = true;
        this.editDialog = false;
      }
    },
    hideFormLogin() {
      this.loginDialog = false
      this.mfaSetAsDefault = ""
      this.mfaUpdateState = ""
    },
    async submitUpdate() {
      const updateToken = localStorage.getItem("update_token");
      const query = {
        domainId: userInfoProvider.getUserInfo().domain_id,
        type: this.updateType,
        data: this.dataUpdate,
        token: updateToken
      };
      try {
        const response = await identityAuthenClient.prepareUpdateMfa(query);
        if (response.error_info && response.error_info.error_code) {
          this.errorLoginUpdate = response.error_info.message
          if (response.error_info.error_code === 403) {
            this.editDialog = false
            this.loginDialog = true
            this.errorLoginUpdate = "Token expired. Please reenter your password!"
          }
        } else {
          if (response.data) {
            this.totpData = response.data
          }
          this.messageUpdate = response.message
          this.requestId = response.request_id
          this.sessionId = response.session_id
          this.verifyInfo = true
          this.loading = false
          this.dataUpdate = ""
        }
      } catch (err) {
        err = JSON.parse(err)
        if (err && err.response && err.response.status === 401) {
          localStorage.removeItem('update_token');
          this.editDialog = false
          this.loginDialog = true
        } else {
          let errorMessage = err
          if (err.response && err.response.body) {
            errorMessage = err.response.body.message, err.response.status;
          }
          this.errorLoginUpdate = errorMessage;

        }
      }
    },
    async onReadyToSubmit(data) {
      const updateToken = localStorage.getItem("update_token");
      const query = {
        domainId: userInfoProvider.getUserInfo().domain_id,
        request_id: this.requestId,
        session_id: this.sessionId,
        token: updateToken,
        otp: data.otp,
        type: this.updateType
      };
      try {
        const response = await identityAuthenClient.verifyUpdate(query);
        if (response.error_info.error_code) {
          this.errorLoginUpdate = response.error_info.message
        } else {
          this.refreshMfas();
          this.editDialog = false
          this.showNoti = true;
          setTimeout(() => {
            this.showNoti = false;
          }, 5000);
        }
      } catch (err) {
        err = JSON.parse(err)
        let errorMessage = err
        if (err.response && err.response.body) {
          errorMessage = err.response.body.message, err.response.status;
        }
        this.errorLoginUpdate = errorMessage;
        if (err && err.response && err.response.status === 401) {
          localStorage.removeItem('update_token');
        }
      }
    },
    async submit(callback) {
      const loginName = localStorage.getItem('login_name')
      const query = {
        domainId: userInfoProvider.getUserInfo().domain_id,
        type: "UsernamePasswordWithToken",
        loginName,
        password: this.data.password,
        requested_permissions: ['update_security_setting']
      };
      try {
        const response = await identityAuthenClient.login(query);
        if (response.error_info.error_code) {
          callback(response.error_info.message);
        } else {
          localStorage.setItem('update_token', response.token)
          if (this.updateType === 'Totp') {
            this.submitUpdate()
          }
          this.loginDialog = false;
          this.data.password = ""
          this.errorLoginUpdate = ""
          if (this.mfaUpdateState) {
            const mfasClone = merge.clone({}, this.mfas)
            mfasClone[this.mfaUpdateState].activated = !mfasClone[this.mfaUpdateState].activated
            this.$set(this.mfas, this.mfaUpdateState, mfasClone[this.mfaUpdateState])
            await this.updateMfa(this.mfaUpdateState, true)
            this.mfaUpdateState = ""
            return
          }
          if (this.mfaSetAsDefault) {
            await this.setAsDefault(this.mfaSetAsDefault)
            this.mfaSetAsDefault = ""
            return
          }
          this.editDialog = true;
        }
      } catch (e) {
        callback(e);
      }
    },
    async refreshMfas(preventUpdateLoading) {
      if (!preventUpdateLoading) {
        this.loading = true;
      }
      try {
        const mfas = await identityAuthenClient.getAllMfa();
        if (mfas.data) {
          this.mfas = mfas.data;

          for (const key in this.mfas) {
            const mfa = this.mfas[key];
            mfa.activated = !mfa.disabled;
          }
        }
      } catch (error) {
        this.initError = error;
      } finally {
        if (!preventUpdateLoading) {
          this.loading = false;
        }
      }
    },
    async onSwitchClick(event, key) {
      if (event) {
        event.stopPropagation()
      }
      const updateToken = localStorage.getItem("update_token");
      this.mfaUpdateState = key
      if (updateToken) {
        this.mfaUpdateState = ""
        this.loginDialog = false;
        const mfasClone = merge.clone({}, this.mfas)
        mfasClone[key].activated = !mfasClone[key].activated
        this.$set(this.mfas, key, mfasClone[key])
        await this.updateMfa(key, true)
      } else {
        this.loginDialog = true;
      }
    },
    async updateMfa(type: string, refreshAll, setAsDefault, preventUpdateLoading) {
      const updateToken = localStorage.getItem("update_token");
      this.updateError = "";
      const mfa = this.mfas[type];
      mfa.disabled = !mfa.activated;
      if (setAsDefault !== undefined) {
        mfa.priority = setAsDefault ? 1 : 0;
      }
      const query = {
        type,
        domainId: userInfoProvider.getUserInfo().domain_id,
        data: mfa,
        token: updateToken
      };
      if (!preventUpdateLoading) {
        this.loading = true;
      }
      try {
        const data: any = await identityAuthenClient.updateMfa(query);
        const errorInfo = data.error_info;
        if (errorInfo && Object.keys(errorInfo).length) {
          this.updateError = errorInfo.message;
          return;
        }
        if (refreshAll) {
          await this.refreshMfas(true);
        }
      } catch (err) {
        err = JSON.parse(err)
        if (err && err.response && err.response.status === 401) {
          localStorage.removeItem('update_token');
          if (this.mfaUpdateState) {
            await this.onSwitchClick(null, this.mfaUpdateState)
          } else if (this.mfaSetAsDefault) {
            await this.setAsDefault(this.mfaSetAsDefault)
          }
        } else {
          let errorMessage = err
          if (err.response && err.response.body) {
            errorMessage = err.response.body.message, err.response.status;
          }
          this.updateError = errorMessage;
        }

      } finally {
        if (!preventUpdateLoading) {
          this.loading = false;
        }
      }
    },
    async setAsDefault(type: string) {
      const updateToken = localStorage.getItem("update_token");
      this.mfaSetAsDefault = type
      if (updateToken) {
        this.mfaSetAsDefault = ""
        this.loginDialog = false;
        this.loading = true;
        for (const mfaType in this.mfas) {
          await this.updateMfa(mfaType, false, mfaType === type, true);
        }
        await this.refreshMfas(true);
        this.loading = false;
      } else {
        this.loginDialog = true;
      }

    },
  },
  created() {
    const query = Object.assign({}, this.$route.query)
    if (query.access_token) {
      delete query.access_token
      this.$router.replace({
        query,
      }).catch(err => err)
    }
    const userInfo: any = userInfoProvider.getUserInfo();
    if (userInfo) {
      this.userInfo = userInfo;
    }
  },
});
